module.exports = __webpack_public_path__ + "img/_PWK2624_-PSedit_.f1884612.jpeg";